import script from "./Completion.vue?vue&type=script&setup=true&lang=ts"
export * from "./Completion.vue?vue&type=script&setup=true&lang=ts"

import "./Completion.vue?vue&type=style&index=0&id=1d088a06&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d088a06"]])

export default __exports__